<template>
	<div class="ss-wrap-content">
		<div class="ss-wrap-slideshow">
			<i v-if="images.length > 1" class="fas fa-chevron-left ss-nav ss-nav-left" @click="setIndex(true)"></i>
			<div class="ss-wrap-images">
				<div v-for="(image, idx) in images" :key="image.src" class="ss-image" @click="$emit('showFullImage', image)">
					<img
						v-show="index == idx"
						:id="`${slideshowID}-${idx}`"
						:src="require(`@/assets/${image.src}`)"
						:alt="image.alt"
						:title="image.alt"
						class="ss-slide-in"
					/>
				</div>
			</div>
			<div class="ss-wrap-dots">
				<div
					v-for="(image, idx) in images"
					:key="image.src"
					class="ss-dot"
					:class="idx == index ? 'ss-focused' : 'ss-unfocused'"
					@click="setIndex(idx)"
				></div>
			</div>
			<i v-if="images.length > 1" class="fas fa-chevron-right ss-nav ss-nav-right" @click="setIndex(false)"></i>
		</div>
	</div>
</template>

<script>
import * as uuid from 'uuid';
export default {
	name: 'Slideshow',
	components: {},
	props: {
		images: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			slideshowID: uuid.v4(),
			index: 0,
		};
	},
	methods: {
		setIndex(minus) {
			if (typeof minus == 'number') {
				this.index = minus;
			} else if (minus) {
				if (this.index == 0) this.index = this.images.length - 1;
				else this.index -= 1;
			} else if (!minus) {
				if (this.index == this.images.length - 1) this.index = 0;
				else this.index += 1;
			}
		},
	},
};
</script>

<style scoped>
.ss-wrap-content {
	height: 750px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	text-align: center;
}

.ss-dot {
	width: 10px;
	height: 10px;
	display: inline-block;
	margin: 10px 5px;
	border-radius: 5px;
	cursor: pointer;
}

.ss-focused {
	background-color: #eeeeee;
}
.ss-unfocused {
	background-color: #aaaaaa;
}

.ss-image {
	overflow: hidden;
}

.ss-image:hover {
	cursor: pointer;
	-webkit-filter: drop-shadow(0px 0px 10px #ffffff);
	filter: drop-shadow(0px 0px 10px #ffffff);
}

.ss-image img {
	margin: 25px 35px;
	max-height: 750px;
}

.ss-nav {
	position: absolute;
	font-size: 30px;
	color: var(--main-color-highlight);
	z-index: 9;
}

.ss-nav:hover {
	cursor: pointer;
	color: var(--secondary-color-highlight);
}

.ss-nav-left {
	left: 5px;
	top: 49%;
}

.ss-nav-right {
	right: 5px;
	top: 49%;
}
</style>
